import React from 'react';
import {Image as PDFImage, Text, View} from '@react-pdf/renderer';
import {StudentResume} from 'src/components/Resume/format-student-for-resume';
import {createHeaderStyles} from 'src/components/Resume/styles';
import PlatformService from 'src/services/PlatformService';

interface Props {
  studentInfo: StudentResume;
}

const ResumeHeader = ({studentInfo}: Props) => {
  const styles = createHeaderStyles();

  const academicInterestStrings = studentInfo.intendedMajor
    ? [studentInfo.intendedMajor]
    : studentInfo.academicInterests;

  return (
    <View>
      {!PlatformService.isNativeApp() && (
        <PDFImage src="/images/raise_hero.png" style={styles.headerImage} />
      )}
      <View style={styles.headerContainer}>
        <View style={styles.infoContainer}>
          <Text style={styles.nameText}>{studentInfo.name}</Text>
          <View>
            <Text style={styles.infoText}>{studentInfo.contactInformation}</Text>
            <View style={styles.pillContainer}>
              {academicInterestStrings.map((interest) => (
                <Text key={interest} style={styles.pill}>
                  {interest}
                </Text>
              ))}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default ResumeHeader;
